define('bwp/loader',[],function()
{
  var loaded = [];

  return {
    load_api: function(url) {
      if (loaded.indexOf(url) !== -1) {
        return;
      }

      var script = document.createElement('script');

      script.src = url;
      document.body.appendChild(script);

      loaded.push(url);
    }
  };
});
